// Function to group sessions by date
export const groupSessionsByDate = (sessions) => {

  // Create an empty object to store sessions grouped by date
  const grouped = {};

  // Loop through each session
  sessions.forEach(session => {

    // If the date doesn't exist in the grouped object, create an empty array
    if (!grouped[session.details.date]) {
      grouped[session.details.date] = [];
    }

    // Push the current session to the corresponding date's array
    grouped[session.details.date].push(session);

  });

  // Convert the grouped object into an array of objects
  return Object.entries(grouped).map(([date, sessionList], index) => ({
    day: `Day ${index + 1}`, // Automatically generate day labels (e.g., Day 1, Day 2, etc.)
    date, // The date of the session
    sessions: sessionList, // List of sessions for that date
  }));

};